module.exports = __webpack_public_path__ + "static/media/icon_lens_adding_gray.691ceb1a.png";